/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { LocationUrls } from '../../core/navigation/LocationUrls';
import { isHomeScreenCcbSwitchEnabled } from '../../core/utils/ccb/CcbSwitchHelper';
import { CollectionScreen } from '../CollectionScreen';
import { ErrorScreen } from '../ErrorScreen';
import { FullScreenPlayback } from '../FullScreenPlayback';
import { GalleryScreen } from '../GalleryScreen';
import { Guide } from '../Guide';
import { EmptyGuide } from '../Guide/EmptyGuide';
import { FilteredGuide } from '../Guide/FilteredGuide';
import EmptyFilteredGuide from '../Guide/FilteredGuide/EmptyFilteredGuide/EmptyFilteredGuide';
import { HomeScreen } from '../HomeScreen';
import { ListViewScreen } from '../ListViewScreen';
import { MyShowsScreen } from '../MyShows';
import { ProgramScreen } from '../ProgramScreen';
import { SettingsRoutes } from '../SettingsScreen/SettingsRoutes';
import { SignInScreen } from '../SignInScreen';
import { SplashScreen } from '../SplashScreen';
import { VodBrowseMainScreen } from '../VodBrowseMainScreen';

const AppRoutes: FunctionComponent = (): JSX.Element => {
    const location = useLocation();

    return (
        <Routes>
            <Route path={LocationUrls.SPLASH_SCREEN} element={<SplashScreen />} />
            <Route path={LocationUrls.ERROR_SCREEN} element={<ErrorScreen />} />
            <Route path={LocationUrls.GUIDE} element={<Guide />} />
            {/* TODO: Remove HomeScreen route on completion of ENABLE_HOMESCREEN_REMOVE_IN_KST_15596 */}
            {isHomeScreenCcbSwitchEnabled() && (
                <Route path={LocationUrls.HOME_SCREEN} element={<HomeScreen />} />
            )}
            <Route path={`${LocationUrls.FILTERED_GUIDE}/*`} element={<FilteredGuide />} />
            <Route path={LocationUrls.EMPTY_FILTERED_GUIDE} element={<EmptyFilteredGuide />} />
            <Route path={LocationUrls.EMPTY_GUIDE} element={<EmptyGuide />} />
            <Route path={`${LocationUrls.MAIN_SETTINGS_SCREEN}/*`} element={<SettingsRoutes />} />
            <Route path={LocationUrls.SIGN_IN_SCREEN} element={<SignInScreen />} />
            <Route path={LocationUrls.VIDEO_PLAYER} element={<FullScreenPlayback />} />
            <Route path={LocationUrls.MY_SHOWS_SCREEN} element={<MyShowsScreen />} />
            <Route path={`${LocationUrls.GALLERY_SCREEN}/*`} element={<GalleryScreen />} />
            {/* Key is given to force re-mount instead of re-rendering */}
            <Route
                path={LocationUrls.COLLECTION_SCREEN}
                element={<CollectionScreen key={location.search} />}
            />
            <Route path={`${LocationUrls.PROGRAM_SCREEN}/*`} element={<ProgramScreen />} />
            <Route path={LocationUrls.VOD_BROWSE_MAIN_SCREEN} element={<VodBrowseMainScreen />} />
            <Route path={LocationUrls.LIST_VIEW_SCREEN} element={<ListViewScreen />} />
        </Routes>
    );
};

export default AppRoutes;
